import type { CourseModule } from "@/core/types";
import { lektionKommentare } from "./lektion-01-kommentare";
import { lektionSprache } from "./lektion-02-sprache";

/**
 * Die Registerkarte „Überprüfen“. Kommentare und die Textsprache kennt
 * Office.js für PowerPoint nicht – beides lesen Prüfmakros.
 */
export const modulUeberpruefen: CourseModule = {
  id: "ueberpruefen",
  title: "Überprüfen und Zusammenarbeiten",
  summary: "Kommentare an der richtigen Stelle, Antworten statt E-Mails, und die richtige Textsprache.",
  level: "Aufbau",
  lessons: [lektionKommentare, lektionSprache],
};
